<div class="dropdown icon-dropdown" (clickOutside)="clickOutside(id)">
  <button class="btn dropdown-toggle" id="visitorButton" type="button" (click)="toggleDropdown(id)">
    <i class="icon-more-alt"></i>
  </button>

  <div class="dropdown-menu dropdown-menu-end" [class.show]="dropdownState[id]">
    <ng-content></ng-content>
  </div>

</div>